<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Vraag bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditQuestionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-1" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="editQuestionForm" lazy-validation>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          label="Stage"
          v-model="selectedQuestion.stageId"
          prepend-icon="info"
          :rules="rules.required"
          :items="stages"
          background-color="background"
          item-text="name"
          item-value="id"
          required
        ></v-select>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          label="Vraagtype"
          v-model="selectedQuestion.type"
          background-color="background"
          prepend-icon="comment"
          :items="questionTypes"
          item-text="label"
          item-value="value"
          hint="Selecteer het vraagtype"
          persistent-hint
        >
        </v-select>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          v-if="activeJourney.type != 'global'"
          label="Filalen"
          v-model="questionBranches"
          prepend-icon="business"
          background-color="background"
          :items="branches"
          item-text="branchName"
          item-value="id"
          hint="Selecteer de vestigingen waar deze vraag van toepassing is."
          persistent-hint
          multiple
          v-on:input="createBranchesObject()"
        >
        </v-select>

        <div
          class="question-wrapper clear"
          v-for="(language, index) in activeJourney.selectedLanguages"
          :key="index"
        >
          <div class="language-flag-wrapper">
            <div class="question-language-flag" v-bind:class="language"></div>
          </div>
          <div class="questionfield-wrapper">
            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              hide-details
              label="Vraag"
              background-color="background"
              v-model="selectedQuestion.question[language]"
              :rules="rules.required"
              counter
              maxlength="100"
              required
            ></v-text-field>
          </div>
        </div>

        <v-switch
          class="pa-0 ma-0 mt-4"
          label="Actief"
          :color="companyPrimaryColor"
          v-model="selectedQuestion.active"
        ></v-switch>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditQuestionDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateQuestion()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "edit-question-form",
  props: {
    branches: Array,
    stages: Array,
    selectedQuestion: Object,
    selectedQuestionOriginal: Object,
    activeJourney: Object,
    activeComp: Object,
  },

  data() {
    return {
      rules: {
        required: [(v) => !!v || "Dit veld is verplicht"],
        counter: (value) => value.length <= 100 || "Max 100 characters",
      },
      feedback: null,
      recordId: null,
      questionBranches: {},
      questionTypes: [
        {
          label: "Beoordeling 1/5",
          value: "rating",
        },
        {
          label: "Feedback achterlaten via tekstveld",
          value: "feedback",
        },
      ],
    };
  },

  created: function() {
    bus.$on("updateQuestionBranches", this.updateBranches);
  },

  methods: {
    updateBranches() {
      // Convert Active Branches Object to Array
      console.log("Converting to Object");

      let activeBranches = this.selectedQuestion.branches;

      Object.filter = (obj, predicate) =>
        Object.keys(obj)
          .filter((key) => predicate(obj[key]))
          .reduce((res, key) => ((res[key] = obj[key]), res), {});

      let filterActiveBranches = Object.filter(
        activeBranches,
        (branch) => branch == true,
      );
      this.questionBranches = _.keysIn(filterActiveBranches);
    },

    createBranchesObject() {
      // Convert selected Branches Array to Object
      this.selectedQuestion.branches = {};
      let selectedBranchesArray = this.questionBranches;
      let selectedBranchesObject = this.selectedQuestion.branches;

      selectedBranchesArray.forEach((branch) => {
        selectedBranchesObject[branch] = true;
      });
    },

    closeEditQuestionDialog() {
      this.$emit("editQuestionDialogChange", false);
    },

    updateQuestion() {
      if (this.selectedQuestion.question) {
        db.collection("questions")
          .doc(this.selectedQuestion.id)
          .update({
            question: this.selectedQuestion.question,
            active: this.selectedQuestion.active,
            type: this.selectedQuestion.type,
            branches: this.selectedQuestion.branches,
            stageId: this.selectedQuestion.stageId,
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Journey Vraag gewijzigd: " + this.activeComp.name,
                extra:
                  "<b>ORIGINELE GEGEVENS</b> " +
                  "<br>" +
                  "<b>Vraag:</b> " +
                  this.selectedQuestionOriginal.question +
                  "<br>" +
                  "<b>Actief:</b> " +
                  this.selectedQuestionOriginal.active +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.selectedQuestionOriginal.type +
                  "<br>" +
                  "<b>Branches:</b> " +
                  JSON.stringify(this.selectedQuestionOriginal.branches) +
                  "<br><br>" +
                  "<b>AANGEPAST GEGEVENS</b> " +
                  "<br>" +
                  "<b>Vraag:</b> " +
                  this.selectedQuestion.question +
                  "<br>" +
                  "<b>Actief:</b> " +
                  this.selectedQuestion.active +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.selectedQuestion.type +
                  "<br>" +
                  "<b>Branches:</b> " +
                  JSON.stringify(this.selectedQuestion.branches),
              })
              .catch((error) => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditQuestionDialog();
          })
          .catch((error) => {
            console.error("Error updating Question: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Question: " + this.activeComp.name,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Het is verplicht om een vraag in te vullen.";
      }
    },
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (
        _.isEqual(this.selectedQuestion, this.selectedQuestionOriginal) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
